package com.example.monetix.utils

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import kotlinx.browser.window

class WebNotificationScheduler : NotificationScheduler {

    private fun requestPermission() {
        val notification = window.asDynamic().Notification
        if (notification != null) {
            notification.requestPermission()
        }
    }

    override fun scheduleDeadlineReminder(hour: Int, minute: Int) {
        requestPermission()
    }

    override fun scheduleSummaryReminder(hour: Int, minute: Int) {
        requestPermission()
    }

    override fun cancelDeadlineReminder() {}

    override fun cancelSummaryReminder() {}
}

@Composable
actual fun rememberNotificationScheduler(): NotificationScheduler {
    return remember { WebNotificationScheduler() }
}